import { render } from "./TheProfessionalPatientAddressFieldset.vue?vue&type=template&id=b82cdacc&ts=true"
import script from "./TheProfessionalPatientAddressFieldset.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalPatientAddressFieldset.vue?vue&type=script&lang=ts"

import "./TheProfessionalPatientAddressFieldset.vue?vue&type=style&index=0&id=b82cdacc&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__